import moment from "moment-timezone";
import React, { useState } from "react";
import ClassModel from "src/models/ClassModel";
import CouponModel from "src/models/CouponModel";
import MembershipOfferingModel from "src/models/MembershipOfferingModel";
import { dateFormat } from "src/utils/constants";
import formatMoney from "src/utils/formatMoney";
import { modals, useModal } from "src/utils/modals";
import { AmountType, Frequency } from "types/code-generator";
import { BorderButton } from "../buttons/BorderButton";
import InputCheckbox from "../inputs/InputCheckbox";
import Modal from "./Modal";

interface Props {
  offering: MembershipOfferingModel | ClassModel;
  coupons: CouponModel[];
  onCancel?: (modal) => void;
  onSubmit: (coupons) => void;
}
const AddCouponModal = modals.create((props: Props) => {
  const modal = useModal();
  const [coupons, setCoupons] = useState(props.offering.coupons);

  function onSubmit() {
    props.onSubmit(coupons);
    modal.hide();
  }

  function onCancel() {
    if (props.onCancel) {
      props.onCancel(modal);
    }

    modal.hide();
  }

  return (
    <Modal
      visible={modal.visible}
      afterClose={modal.remove}
      title="Add Coupon"
      handleCancel={onCancel}
      footer={
        <>
          <BorderButton type="submit" onClick={onSubmit}>
            Apply
          </BorderButton>
          <BorderButton onClick={onCancel}>Cancel</BorderButton>
        </>
      }
    >
      {props.coupons.map((c) => {
        const off =
          c.amountType === AmountType.Percent
            ? `${c.amount}%`
            : `$${formatMoney(c.amount)}`;
        const expiration = moment(c.expirationDate).format(dateFormat);
        const frequencyString =
          c.frequency === Frequency.Monthly ? "monthly" : "one-time";

        return (
          <React.Fragment key={c.id}>
            <div className="px-4">
              <InputCheckbox
                onChange={(checked) => {
                  if (checked) {
                    setCoupons([...coupons, c]);
                  } else {
                    setCoupons(coupons.filter((cc) => cc.id !== c.id));
                  }
                }}
                checked={Boolean(coupons.find((cc) => cc.id === c.id))}
              >
                <p className="mb-0">
                  <strong>{c.title}</strong>
                  <br />
                  Code: {c.code}
                  <br />
                  {off} off {frequencyString} through {expiration}
                </p>
              </InputCheckbox>
            </div>
            <hr />
          </React.Fragment>
        );
      })}
    </Modal>
  );
});

export default AddCouponModal;
